/* eslint-disable react/destructuring-assignment */

import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { withTranslation } from 'react-i18next';
import { PortalCourseGroup } from '../../PortalCourse/PortalCourseGroup';
import { PortalQualificationPropType } from '../../../../CustomPropTypes/PortalPropTypes';
import { defaultStrings } from '../../PortalShared';
import './PortalQualificationCourseList.scss';

const _PortalQualificationCourseList = function (props) {
  const {
    anchor,
    title,
    blurb,
    qualification,
    onCtaButtonClicked,
    onEnrolInCourse,
    expandFirstCourse,
    t,
  } = props;
  const showElectiveCourses =
    qualification.get('electiveCourses').size > 0 &&
    qualification.get('requiredElectives') > 0;

  return (
    <portal-qualification-course-list id={anchor}>
      <div className="row portal-section">
        <div className="columns small-11 small-centered medium-10 medium-centered">
          <h2>{title}</h2>
          <h4 className="portal-section-blurb">{blurb}</h4>
          {qualification.get('coreCourses').size > 0 && (
            <PortalCourseGroup
              courses={qualification.get('coreCourses')}
              title={
                showElectiveCourses
                  ? t('capitalized_core_course_with_count', {
                      count: qualification.get('coreCourses').size,
                    })
                  : t('capitalized_course_with_count', {
                      count: qualification.get('coreCourses').size,
                    })
              }
              {...{ onCtaButtonClicked, onEnrolInCourse, expandFirstCourse }}
            />
          )}
          {showElectiveCourses && (
            <PortalCourseGroup
              courses={qualification.get('electiveCourses')}
              title={t('choose_elective_course', {
                elective: qualification.get('requiredElectives'),
                count: qualification.get('electiveCourses').size,
              })}
              {...{ onCtaButtonClicked, onEnrolInCourse }}
            />
          )}
        </div>
      </div>
    </portal-qualification-course-list>
  );
};

_PortalQualificationCourseList.displayName = 'PortalQualificationCourseList';
_PortalQualificationCourseList.propTypes = {
  anchor: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  blurb: PropTypes.string.isRequired,
  expandFirstCourse: PropTypes.bool.isRequired,
  qualification: PortalQualificationPropType.isRequired,
  onCtaButtonClicked: PropTypes.func.isRequired,
  onEnrolInCourse: PropTypes.func.isRequired,
  defaultStrings: ImmutablePropTypes.map,
  t: PropTypes.func.isRequired,
};
_PortalQualificationCourseList.defaultProps = { defaultStrings };
_PortalQualificationCourseList.contextTypes = {
  strings: ImmutablePropTypes.map,
};

export const PortalQualificationCourseList = withTranslation('landingPages')(
  _PortalQualificationCourseList
);
